var _rect, _rect2, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgActiveWarning = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 41.1429,
    height: 41.1429,
    transform: "translate(11.5488 10.7068)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3661 18.3218L48.8269 39.9477C49.1011 40.5932 49.2211 41.1181 49.2554 41.6634C49.324 42.9374 48.8783 44.1757 48.0042 45.1287C47.13 46.0782 45.9474 46.6388 44.6619 46.7067H19.569C19.0376 46.6745 18.5063 46.5539 18.0092 46.367C15.5239 45.3648 14.3241 42.545 15.3354 40.1006L27.8819 18.3065C28.3104 17.5404 28.9617 16.8796 29.7672 16.4549C32.0983 15.1622 35.0635 16.0116 36.3661 18.3218ZM33.6066 32.5737C33.6066 33.3891 32.9381 34.0702 32.1154 34.0702C31.2927 34.0702 30.6071 33.3891 30.6071 32.5737V27.7681C30.6071 26.9511 31.2927 26.2903 32.1154 26.2903C32.9381 26.2903 33.6066 26.9511 33.6066 27.7681V32.5737ZM32.1154 39.8797C31.2927 39.8797 30.6071 39.1986 30.6071 38.3849C30.6071 37.5678 31.2927 36.8884 32.1154 36.8884C32.9381 36.8884 33.6066 37.5525 33.6066 38.3662C33.6066 39.1986 32.9381 39.8797 32.1154 39.8797Z",
    fill: "#D29822"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgActiveWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Active-warning.b1d95d3c.svg";
export { ForwardRef as ReactComponent };